import { render } from "./cart_package.vue?vue&type=template&id=5fe6cd2c&scoped=true"
import script from "./cart_package.vue?vue&type=script&lang=js"
export * from "./cart_package.vue?vue&type=script&lang=js"

import "./cart_package.vue?vue&type=style&index=0&id=5fe6cd2c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fe6cd2c"]])

export default __exports__